module.exports = __webpack_public_path__ + "static/media/basketball.4171cb80.jpg";